<template>
    <div class="page add-hospital">
        <div class="title">
            添加医院信息
        </div>
        <van-form ref="addFrom" class="add-hospital-form" @submit="onSubmit">
            <van-field required label-class="form-title" input-align="right" v-model="form.name" name="医院名称" label="医院名称" placeholder="医院名称" :rules="[{ required: true },{validator: validatorStr, message: '格式错误'}]" />
            <van-field required label-class="form-title" input-align="right" clickable readonly name="医院等级" :value="form.level" label="医院等级" placeholder="请选择" @click="levelPicker = true" :rules="[{ required: true }]"/>
                <van-popup v-model="levelPicker" position="bottom">
                    <van-picker show-toolbar :columns="level" :value-key="'name'" @confirm="onLevelConfirm" @cancel="levelPicker = false" />
                </van-popup>
        </van-form>

        <div class="control">
            <van-button class="submit" color="#D3172E" round block type="info" native-type="submit" @click="addHospital()">确定</van-button>
        </div>
    </div>
</template>

<script>
    import Interface from "@/util/interface"
    import {
        HospitalLevel
    } from "@/util/dict"
    export default {
        name: 'home',
        data() {
            return {
                formData: {},
                form:{
                    name: '',
                    level: ''
                },
                levelPicker: false,
                level: HospitalLevel
            }
        },
        methods: {
            validatorStr(val) {
                if(/^(?![0-9]+$)(?!([a-zA-Z])\1+$).{2,}$/.test(val)) {
                    return true
                }
                return false
            },
            onSubmit(){},
            onLevelConfirm(val) {
                this.form.level = val
                this.levelPicker = false
            },
            addHospital(){
                this.$refs['addFrom'].validate().then(() => {
                let arr = this.formData.city_name ? this.formData.city_name.split('/') : []
                let user = JSON.parse(localStorage.getItem('user')),
                    mobile = user && user.mobile ? user.mobile : ''
                let param = {
                    name: this.form.name,
                    pccm: this.form.level,
                    user_mobile: mobile,
                    province_id: this.formData.province_id,
                    province: arr[0] || '',
                    city_id: this.formData.city_id,
                    city: arr[1] || '',
                    municipality_id: this.formData.municipality_id,
                    municipality: arr[2] || ''
                }
                console.log("param:", param)
                // return 

                Interface.getData('post',Interface.user.hospital, param).then((res)=>{
                    if(res.code == 0){
                        this.$toast.success("添加成功")
                        this.setHospital(res.data)
                    } else if(res.code == 400){
                        this.$toast.fail(res.message)
                        setTimeout(() => {
                            this.$router.push({
                                name: "choose-hospital",
                            })
                        }, 500);
                    } else{
                        this.$toast.fail(res.message)
                    }
                })
                }).catch((err) => {
                    console.log('err:', err)
                    if(!err || !err.length) return
                    let msgstr = err[0].message || `${err[0].name}不能为空`
                    this.$toast.fail(msgstr);
                })
            },
            setHospital(data){
                let formData = JSON.parse(localStorage.getItem('add-info'))
                formData.hospital_name = data.name
                formData.hospital_id = data.id
                formData.hospital_level_name = data.pccm
                localStorage.setItem('add-info',JSON.stringify(formData))
                this.$router.push({
                    name : "add-info",
                })
                // this.$router.push({
                //     name : "choose-hospital",
                // })
            },
        },
        created() {
            this.formData = JSON.parse(localStorage.getItem('add-info'))
            // Interface.getShareInfo(this,"","","")
            // this.fetch('hospital')
        },
    }
</script>

<style lang="scss">
    @import "./add-hospital.scss";
</style>



// WEBPACK FOOTER //
// src/views/login/choose-hospital/add-hospital.vue